import { DialogContentText, TextField } from "@material-ui/core";
import ActionDialog from "@saleor/components/ActionDialog";
import FormSpacer from "@saleor/components/FormSpacer";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import HotSearchs from "@saleor/hotsearch/components/HotsearchList/HotsearchList";
import {
  useHotsearchCreateMutation,
  usehotsearchDeleteMutation,
  useHotSearchReorderMutation,
  useUpdateHotsearchMutation
} from "@saleor/hotsearch/mutations";
import { useHotsearchListQuery } from "@saleor/hotsearch/queries";
import {
  hotsearchListUrl,
  HotsearchListUrlDialog,
  HotsearchListUrlQueryParams
} from "@saleor/hotsearch/urls";
import { commonMessages } from "@saleor/intl";
import { ReorderEvent } from "@saleor/types";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { move } from "@saleor/utils/lists";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface HotSearchListProps {
  params: HotsearchListUrlQueryParams;
}

const HotsearchList: React.FC<HotSearchListProps> = ({ params }) => {
  const notify = useNotifier();
  const navigate = useNavigator();
  const intl = useIntl();

  const { data, refetch } = useHotsearchListQuery({
    variables: {
      first: 100
    }
  });
  const [hotWorldReorder] = useHotSearchReorderMutation({
    onCompleted: data => {
      if (data.hotsearchReorder.errors.length !== 0) {
        notify({
          status: "error",
          text: "error"
        });
      }
      refetch();
    }
  });
  const handlehotworldReorder = ({ newIndex, oldIndex }: ReorderEvent) =>
    hotWorldReorder({
      optimisticResponse: {
        hotsearchReorder: {
          __typename: "HotSearchReorder",
          hotSearchList: move(
            data.hotSearch.edges.map(edge => edge.node)[oldIndex],
            data.hotSearch.edges.map(edge => edge.node),
            (a, b) => a.id === b.id,
            newIndex
          ),
          errors: []
        }
      },
      variables: {
        move: {
          id: data.hotSearch.edges.map(edge => edge.node)[oldIndex].id,
          sortOrder: newIndex - oldIndex
        }
      }
    });
  const [openModal, closeModal] = createDialogActionHandlers<
    HotsearchListUrlDialog,
    HotsearchListUrlQueryParams
  >(navigate, params => hotsearchListUrl(params), params);
  const [hotsearchDelete, hotsearchDeleteOpts] = usehotsearchDeleteMutation({
    onCompleted: data => {
      if (data.hotsearchDelete.errors.length === 0) {
        closeModal();
        refetch();
      }
    }
  });
  const [updateHotworld, updateHotworldOpts] = useUpdateHotsearchMutation({
    onCompleted: data => {
      if (data.hotsearchUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
        closeModal();
        refetch();
      }
    }
  });

  const [createHotworld, createHotworldOpts] = useHotsearchCreateMutation({
    onCompleted: data => {
      if (data.HotsearchCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.savedChanges)
        });
        closeModal();
        refetch();
      }
    }
  });

  const [hosWorld, setHosWorld] = React.useState<string>(null);
  const [description, setDescription] = React.useState<string>(null);
  return (
    <>
      <HotSearchs
        hotsearch={data?.hotSearch?.edges?.map(edge => edge.node)}
        onReorder={handlehotworldReorder}
        onDelete={id => openModal("delete", { id })}
        onAdd={() => openModal("create")}
        onUpdate={(id, name, usedfor) => {
          openModal("update", { id });
          setHosWorld(name);
          setDescription(usedfor);
        }}
      />
      <ActionDialog
        open={params.action === "delete"}
        onClose={closeModal}
        confirmButtonState={hotsearchDeleteOpts.status}
        onConfirm={() =>
          hotsearchDelete({
            variables: {
              id: params.id
            }
          })
        }
        variant="delete"
        title={intl.formatMessage({
          defaultMessage: "Delete hotsearch",
          description: "dialog header"
        })}
      >
        <DialogContentText>
          <FormattedMessage
            defaultMessage="Are you sure you want to cancel the sorting of this ins in this hotSearch?"
            description="dialog content"
          />
        </DialogContentText>
      </ActionDialog>
      <ActionDialog
        open={params.action === "update"}
        onClose={closeModal}
        confirmButtonState={updateHotworldOpts.status}
        onConfirm={() =>
          updateHotworld({
            variables: {
              id: params.id,
              input: {
                hotWord: hosWorld,
                description
              }
            }
          })
        }
        variant="default"
        title={intl.formatMessage({
          defaultMessage: "Update HotWorld",
          description: "dialog header"
        })}
      >
        <TextField
          label={intl.formatMessage({
            defaultMessage: "Hot World",
            description: "Hot World"
          })}
          fullWidth
          name="hotworld"
          value={hosWorld}
          onChange={event => setHosWorld(event.target.value)}
        />
        <FormSpacer />
        <TextField
          label={intl.formatMessage({
            defaultMessage: "Used For",
            description: "Used For"
          })}
          fullWidth
          name="description"
          value={description}
          onChange={event => setDescription(event.target.value)}
        />
      </ActionDialog>
      <ActionDialog
        open={params.action === "create"}
        onClose={closeModal}
        confirmButtonState={createHotworldOpts.status}
        onConfirm={() =>
          createHotworld({
            variables: {
              input: {
                hotWord: hosWorld,
                description
              }
            }
          })
        }
        variant="default"
        title={intl.formatMessage({
          defaultMessage: "Create HotWorld",
          description: "dialog header"
        })}
      >
        <TextField
          label={intl.formatMessage({
            defaultMessage: "Hot World",
            description: "Hot World"
          })}
          fullWidth
          name="hotworld"
          value={hosWorld}
          onChange={event => setHosWorld(event.target.value)}
        />
        <FormSpacer />
        <TextField
          label={intl.formatMessage({
            defaultMessage: "Used For",
            description: "Used For"
          })}
          fullWidth
          name="description"
          value={description}
          onChange={event => setDescription(event.target.value)}
        />
      </ActionDialog>
    </>
  );
};
export default HotsearchList;
